exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-audio audio {\n  display: none;\n}\n.circle-audio .ant-progress-circle.ant-progress-status-success .ant-progress-text {\n  color: #53626f;\n}\n.circle-audio .ant-progress-text .anticon {\n  cursor: pointer;\n}\n.circle-audio .ant-progress-text .anticon.icon-play {\n  margin-left: 2px;\n}\n", ""]);

// exports
